import { render } from "./mascus.vue?vue&type=template&id=5f88c822"
import script from "./mascus.vue?vue&type=script&lang=js"
export * from "./mascus.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/maskingruppen-new/maskingruppen-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__